export default __webpack_public_path__ + "static/media/Safety.aa8972eb.svg";